import { NgClass } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DomSanitizer } from '@angular/platform-browser';
import {
  Subject,
  debounceTime,
  distinctUntilChanged,
  takeUntil,
  tap,
} from 'rxjs';
import { MAGNIFY_CLOSE_ICON, MAGNIFY_ICON } from './constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'commonui-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    ReactiveFormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
})
export class SearchComponent implements AfterViewInit, OnDestroy {
  searchControl = new FormControl<string>('');

  @Input() showSearch = false;
  stop$ = new Subject<boolean>();
  @Input() autoFilter = true;
  @Output() searchText = new EventEmitter<string>();
  @ViewChild('searchInput') searchInput!: ElementRef;

  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIconLiteral(
      'magnify',
      sanitizer.bypassSecurityTrustHtml(MAGNIFY_ICON)
    );

    iconRegistry.addSvgIconLiteral(
      'magnify-close',
      sanitizer.bypassSecurityTrustHtml(MAGNIFY_CLOSE_ICON)
    );
  }

  ngAfterViewInit(): void {
    if (this.autoFilter) {
      this.searchControl.valueChanges
        .pipe(
          debounceTime(700),
          distinctUntilChanged(),
          tap((v) => {
            this.searchText.emit(v ?? undefined);
          }),
          takeUntil(this.stop$)
        )
        .subscribe();
    }
  }

  ngOnDestroy(): void {
    this.stop$.next(true);
    this.stop$.complete();
  }

  initSearch(): void {
    this.showSearch = !this.showSearch;
    if (this.showSearch === true) {
      setTimeout(() => {
        this.searchInput.nativeElement.focus();
      }, 0);
    } else {
      this.clean();
    }
  }

  clean(): void {
    this.searchControl.setValue('');
    this.showSearch = false;
    this.searchText.emit('');
  }

  clear(): void {
    this.clean();
    setTimeout(() => {
      this.showSearch = true;
    }, 0);
    setTimeout(() => {
      this.searchInput.nativeElement.focus();
    }, 5);
  }

  onSearch(): void {
    if (this.searchControl.value?.trim() === '' || this.autoFilter === true) {
      return;
    }
    this.searchControl.value;
  }
}
